import Folder from '@/models/Folder';
import Timeline from '@/models/Timeline';
import { FolderRequests } from './generated/Folder'
import { TimelinePermissions } from '@/models/TimelineAccess';

export default class FolderCommands
{
    static get raw()
    {
        return FolderRequests;
    }

    static async CreateFolder(name: string, description: string)
    {
        return await FolderRequests.Folder_Create({name, description});
    }

    static async SetTimelineFolder(timeline: Timeline, folder: Folder)
    {
        return await FolderRequests.Folder_SetTimelineFolder({
            folderid: folder == null ? null : folder.id,
            timelineid: timeline.id
        });
    }

    static async SetTimelineFolderByID(timelineid: number, folderid: number | null)
    {
        return await FolderRequests.Folder_SetTimelineFolder({
            folderid,
            timelineid
        });
    }

    static async GetAllPermissions(folderid: number)
    {
        return await FolderRequests.Folder_GetAllPermissions({folderid});
    }

    static async SetUserPermission(folderid: number, userid: string, permissions: TimelinePermissions)
    {
        return await FolderRequests.Folder_SetUserPermissions({
            folderid,
            userid,
            permissions
        });
    }
}